module.exports = __webpack_public_path__ + "static/img/bk.bb9b2c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bk.png
// module id = WOE0
// module chunks = 1